import apiClient from 'helpers/api-client';

function fetchDocuments({ projectId, sortNewestFirst = true }) {
  const order = sortNewestFirst ? 'DESC' : 'ASC';

  return () => {
    const path = `/locations/${projectId}/documents`;
    return apiClient.get(path, { order }).then((documents) => {
      return documents;
    });
  };
}

function createDocumentForProject(projectId, fileUrl, fileName, accessLimited) {
  return () => {
    const path = `locations/${projectId}/documents`;
    const documentData = {
      url: fileUrl,
      name: fileName,
      access_limited: accessLimited,
    };
    return apiClient.post(path, { document: documentData });
  };
}

function updateDocument(documentId, data) {
  return () => {
    return apiClient.put(`/documents/${documentId}`, { document: data });
  };
}

function deleteDocument(documentId, keepOriginal) {
  const requestBody = {
    data: {
      keep_original_copy: keepOriginal,
    },
  };
  return () => {
    return apiClient.delete(`/documents/${documentId}`, requestBody);
  };
}

function fetchDocument(documentId) {
  return () => {
    return apiClient.get(`/documents/${documentId}`);
  };
}

export {
  fetchDocuments,
  createDocumentForProject,
  updateDocument,
  deleteDocument,
  fetchDocument,
};
